import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button, Popover, PopoverHeader, PopoverBody, UncontrolledPopover, } from "reactstrap";
import styles from "./styles";
import { Checkbox } from "react-inputs-validation";
import Formulario from "../Generales/Formulario";
import Steps from "../Generales/Steps";
import Page from "../Page";


const TablaCoberturasIndividual = (
    {
        planesComparador,
        planSeleccionadoMain,
        setPlanSeleccionadoMain,
        coberturasAdicionalesComparador,
        setCoberturasAdicionalesComparador,
        coberturasSeleccionadas,
        valorAsegurado,
        limiteAmparo,
        codigoProductoEspecial
    }
) => {



    const [bloquearAmparo, setBloquearAmparo]= useState(false)
    const [codEspecial, setCodEspecial]= useState(
        codigoProductoEspecial ? codigoProductoEspecial : ''
        //'pits'
    )
    const [popoverOpen, setPopoverOpen] = React.useState(false);
    const [popover, setPopover] = useState(
        {
            titulo: '',
            descripcion: ''
        }
    )
    const [planes, setPlanes] = useState(planesComparador)

    const [planSeleccionado, setPlanSeleccionado] = useState(
        planSeleccionadoMain ? planSeleccionadoMain : planes.filter(plan => plan.visible === true)[0]
    )


    useEffect(() => {
        if (!planSeleccionadoMain) {
            setPlanSeleccionadoMain(planes.filter(plan => plan.visible === true)[0])
        } else {
            setPlanSeleccionado(planSeleccionadoMain)
        }
    }, [])

    useEffect(()=>{
        const aplica = planSeleccionado.coberturasAdicionales.find(cob=>  cob.aplica == true && cob.codigo =='amparoPatrimonial')
        console.log('coberturasAdicionales22222', valorAsegurado,aplica)

        console.log()

        if(valorAsegurado>=(limiteAmparo? limiteAmparo:30000) && aplica){
        const encontrado = coberturasAdicionalesComparador.find(cob => cob.codigo == aplica.codigo)

        setBloquearAmparo(true)

        console.log('coberturasAdicionales',encontrado)

        if(!encontrado){

            const clonedData = [...coberturasAdicionalesComparador];



            const existe = clonedData.findIndex(data => data.codigo === aplica.codigo)

            clonedData.push({ codigo: aplica.codigo })

           

            setCoberturasAdicionalesComparador(clonedData, true)

        }
        }else{
            setBloquearAmparo(false)
        }
    },[valorAsegurado, planSeleccionado, coberturasAdicionalesComparador])

    useEffect(() => {
        console.log('clonedData', planes);
    
        if (!planSeleccionadoMain) {
            setPlanSeleccionadoMain(planes.filter(plan => plan.visible === true)[0]);
        } else {
            setPlanSeleccionado(planSeleccionadoMain);
        }
    
        // Siempre filtrar "objetosOlvidados"
        let planAux = { ...planSeleccionado };
    
        if (planAux.coberturasAdicionales) {
            planAux.coberturasAdicionales = planAux.coberturasAdicionales.filter(cobertura => cobertura.codigo !== 'objetosOlvidados');
        }
    
        setPlanSeleccionado(planAux);
    }, [planSeleccionadoMain]);

    useEffect(() => {

        console.log('coberturasSeleccionadas', coberturasSeleccionadas, planSeleccionado)


        var nuevoArray = []

        if (coberturasSeleccionadas) {

            planSeleccionado.coberturasAdicionales.forEach(element => {

                var coberturaEncontrada = coberturasSeleccionadas[element.codigo]

                if (coberturaEncontrada) {
                    nuevoArray.push({
                        codigo: element.codigo
                    })
                }
            });


            console.log('element', nuevoArray)

            setCoberturasAdicionalesComparador(nuevoArray, false)

        }



    }, [])

    return (

        <main >


            <div >
                <div>
                    {codEspecial !== 'pits' &&
                        <>
                            <span style={styles.datosDelVehCulo}>
                                Coberturas
                            </span>


                            <div style={{ marginTop: '20px' }}>
                                <div style={styles.divPreguntas}>
                                    <div style={styles.divCoberturas}>
                                        <div style={styles.divTitulo}>
                                            <div style={styles.divEncabezado}>
                                                <span style={styles.tituloEncabezado}>
                                                    Coberturas
                                                </span>

                                            </div>
                                            <div style={{ ...styles.divCategoriaPrecio }}>
                                                <span style={styles.tituloCoberturasPrecio}>

                                                </span>
                                            </div>
                                            {planes[2].coberturas.map((cobertura, index) => {
                                                return (
                                                    <div style={{ ...styles.divCategoriaPrecio2 }}>

                                                        <span style={styles.tituloCategoria2} onClick={() => setPopover({ titulo: cobertura.titulo, descripcion: cobertura.descripcion })}>
                                                            <div id={"Popover1"} style={styles.elipse}>
                                                                <i style={styles.elipseText}
                                                                    className='fa fa-question'
                                                                    aria-hidden='true'
                                                                />
                                                            </div>




                                                            {cobertura.titulo}
                                                        </span>

                                                    </div>
                                                )
                                            })}
                                        </div>


                                        {planes.filter(plan => plan.visible === true).map(plan => {
                                            return (
                                                <div style={styles.divContainerCategoriaSeleccionada}>
                                                    <div style={plan.titulo === planSeleccionado.titulo ? styles.divCategoriaSeleccionada : styles.divCategoria}>
                                                        <div style={{ ...styles.divCategoriaTitulo, backgroundColor: plan.color }}>
                                                            <span style={styles.tituloCoberturasMain}>
                                                                {plan.titulo}
                                                            </span>
                                                        </div>

                                                        <div style={{ ...styles.divCategoriaPrecio }}>
                                                            <span style={styles.tituloCoberturasPrecio}>
                                                                ${parseFloat(plan.primaTotal).toFixed(2)}
                                                            </span>
                                                        </div>
                                                        {plan.coberturas.map(cobertura => {
                                                            return (
                                                                <div style={{ ...styles.divCategoriaPrecio }}>
                                                                    {cobertura.check ?
                                                                        <div style={styles.divCheck}>
                                                                            <i style={styles.check}
                                                                                className='fa fa-check'
                                                                                aria-hidden='true'

                                                                            />

                                                                        </div>
                                                                        : <div style={styles.divCheckOut}>
                                                                            <i style={styles.check}
                                                                                className='fa fa-minus'
                                                                                aria-hidden='true'
                                                                            />

                                                                        </div>
                                                                    }

                                                                </div>
                                                            )
                                                        })}

                                                        <div style={{ ...styles.divCategoriaPrecio }}>



                                                        </div>
                                                    </div>

                                                    <div style={{ ...styles.divCategoriaPrecio }}>
                                                        {/*   <Button style={{ width: '200px' }} onClick={() => setPlanSeleccionado(plan)}>
                                                                                Seleccionar
                                                                            </Button> */}

                                                        <div
                                                            style={planSeleccionado.titulo == plan.titulo ? styles.botonActivo : styles.botonInactivo}
                                                            onClick={() => {
                                                                setPlanSeleccionado(plan)
                                                                setPlanSeleccionadoMain(plan)
                                                            }}
                                                        >
                                                            <span
                                                                style={planSeleccionado.titulo == plan.titulo ? styles.textoBotonActivo : styles.textoBotonInactivo}
                                                                onClick={() => {
                                                                    setPlanSeleccionado(plan)
                                                                    setPlanSeleccionadoMain(plan)
                                                                }}
                                                            >
                                                                Elijo esta opción

                                                            </span>
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        })}





                                    </div>



                                </div>
                            </div>
                        </>
                    }



{planSeleccionado.coberturasAdicionales &&
    <div style={styles.divPreguntas2}>
        <div style={styles.divCoberturas2}>
            <div style={styles.divTitulo3}>
                <div style={styles.divEncabezado2}>
                    <span style={styles.tituloEncabezado2}>
                        Coberturas adicionales
                    </span>
                </div>
                <div style={{ ...styles.divCategoriaPrecio }}>
                    <span style={styles.tituloCoberturasPrecio}>
                    </span>
                </div>
                {/* Aquí aplicas el filtro */}
                {planSeleccionado.coberturasAdicionales
                    .filter(cobertura => cobertura.codigo !== 'objetosOlvidados')
                    .map(cobertura => (
                        <div style={{ ...styles.divCategoriaPrecio2 }}>
                            <span style={styles.tituloCategoria2} onClick={() => setPopover({ titulo: cobertura.titulo, descripcion: cobertura.descripcion })}>
                                <div id={"Popover1"} style={styles.elipse}>
                                    <i style={styles.elipseText}
                                        className='fa fa-question'
                                        aria-hidden='true'
                                    />
                                </div>
                                {cobertura.titulo}
                            </span>
                        </div>
                    ))
                }
            </div>

            <div style={styles.divTitulo2}>
                <div style={styles.divEncabezado3}>
                </div>
                <div style={{ ...styles.divCategoriaPrecio3 }}>
                </div>
                {planSeleccionado.coberturasAdicionales
                    .filter(cobertura => cobertura.codigo !== 'objetosOlvidados') // Aquí también aplicas el filtro
                    .map(cobertura => (
                        cobertura.aplica ?
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ ...styles.divCategoriaPrecio5 }}>
                                    <div style={coberturasAdicionalesComparador.find(data => data.codigo === cobertura.codigo) ? styles.divBotonQuitar : styles.divBotonAgregar}
                                        onClick={() => {
                                            const clonedData = [...coberturasAdicionalesComparador];
                                            const existe = clonedData.findIndex(data => data.codigo === cobertura.codigo);
                                            if (existe === -1) {
                                                clonedData.push({ codigo: cobertura.codigo });
                                            } else {
                                                clonedData.splice(existe, 1);
                                            }
                                            setCoberturasAdicionalesComparador(clonedData, true);
                                        }}
                                    >
                                        <span style={coberturasAdicionalesComparador.find(data => data.codigo === cobertura.codigo) ? styles.textoBotonQuitar : styles.textoBotonAgregar}>
                                            {
                                                coberturasAdicionalesComparador.find(data => data.codigo === cobertura.codigo) ? 'AGREGADO' : 'AGREGAR'
                                            }
                                        </span>
                                    </div>
                                </div>
                                {coberturasAdicionalesComparador.find(data => data.codigo === cobertura.codigo) &&
                                    cobertura.codigo !== 'amparoPatrimonial' || (cobertura.codigo == 'amparoPatrimonial' && !bloquearAmparo && (coberturasAdicionalesComparador.find(data => data.codigo === cobertura.codigo))) ?
                                    <div>
                                        <div style={{ ...styles.divCategoriaPrecio6 }}>
                                            <div style={styles.divBotonQuita2}
                                                onClick={() => {
                                                    const clonedData = [...coberturasAdicionalesComparador];
                                                    const existe = clonedData.findIndex(data => data.codigo === cobertura.codigo);
                                                    if (existe === -1) {
                                                        clonedData.push({ codigo: cobertura.codigo });
                                                    } else {
                                                        clonedData.splice(existe, 1);
                                                    }
                                                    setCoberturasAdicionalesComparador(clonedData, true);
                                                }}
                                            >
                                                <span style={styles.textoBotonQuitar2}>
                                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div> : null
                                }
                            </div>
                            :
                            <div style={{ ...styles.divCategoriaPrecio5 }}>
                                <span style={styles.tituloCoberturasNoAplica}>
                                    No aplica
                                </span>
                            </div>
                    ))
                }
            </div>
        </div>

        <UncontrolledPopover
            placement="bottom" isOpen={popoverOpen}
            target={"Popover1"}
            trigger="legacy"
            toggle={() => { setPopoverOpen(!popoverOpen) }}>
            <PopoverHeader style={styles.popHeader}>{popover.titulo}</PopoverHeader>
            <PopoverBody>{popover.descripcion}</PopoverBody>
        </UncontrolledPopover>
    </div>
}



                </div>
            </div>
        </main>
    );
};
export default TablaCoberturasIndividual;
